var keyMirror = require('keymirror');

module.exports = keyMirror({
    UNAUTHORIZED_EXCEPTION: null,
    RESPONSE_RECIEVED: null,
    RESPONSE_CHANGE_EVENT: null,
    SAVED_TAG: null,
    FILTER_CHANGED: null,
    BULK_EDIT_POST:null,
});